// extracted by mini-css-extract-plugin
export default {"title_container":"SubHeader_title_container__imUd0","title":"SubHeader_title__zg-mr"};